"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var VERICAL_ALIGN = {
  TOP: 'flex-start',
  CENTER: 'center',
  BOTTOM: 'flex-end'
};
var _default = VERICAL_ALIGN;
exports["default"] = _default;